﻿"use strict";
import creator from '../elementCreator';

var privateFns;
privateFns = {
	addBaselayerSwitcher: function (parent, picture2) {
		var div = creator.createDiv({css: "layerswitcher"});
		var button = creator.createButton({
			id: "buttonswitchid",
			title: "Bytt mellom bakgrunnskart og flyfoto",
			ariaLabel: "Bytt mellom bakgrunnskart og flyfoto"
		});
		button.style.background = "url("+picture2+")";
		div.appendChild(button);
		if (!parent) {
			div.className += " layerswitcher-standalone";
			$("#header").after(div);
		}else{
			parent.appendChild(div);
		}
	},
	initBaselayerSwitcher: function (map, layer1, layer2, picture1, picture2) {
		$(".layerswitcher").find("button").click(function (e) {	
		var offLayer = map.getLayerById(layer2);
		var onLayer = map.getLayerById(layer1);
			if ($(e.currentTarget).hasClass("switcher-bakgrunn")) {
				offLayer.setVisible(false);
				onLayer.setVisible(true);
				onLayer.setZIndex(-1);
				document.getElementById("buttonswitchid").style.background =  "url("+picture2 + ")";
				if(onLayer.get("dependent")){
						map.getLayerById(onLayer.get("dependent")).setVisible(true);
					if(document.getElementById(onLayer.get("dependent"))){
						document.getElementById(onLayer.get("dependent")).checked = true;			
					}
					if(offLayer.get("dependent")){
						map.getLayerById(offLayer.get("dependent")).setVisible(false);
						if(document.getElementById(offLayer.get("dependent"))){
							document.getElementById(offLayer.get("dependent")).checked = true;
						}
					}
				}
			} else {
				onLayer.setVisible(false);
				offLayer.setVisible(true);
				offLayer.setZIndex(-1);
				document.getElementById("buttonswitchid").style.background = "url("+picture1 +")";
				if(offLayer.get("dependent")){
					map.getLayerById(offLayer.get("dependent")).setVisible(true);
					if(document.getElementById(offLayer.get("dependent"))){
						document.getElementById(offLayer.get("dependent")).checked = true;			
					}
					if(onLayer.get("dependent")){
						map.getLayerById(onLayer.get("dependent")).setVisible(false);
						if(document.getElementById(onLayer.get("dependent"))){
							document.getElementById(onLayer.get("dependent")).checked = true;			
						}
					}
				}
			}
			$(e.currentTarget).toggleClass("switcher-bakgrunn");
		});
	},
}

// Legg til ekstra css-filer
$("head").append("<link rel='stylesheet' type='text/css' href='./css/baselayerSwitcherPlugin.css'>"); 
    
export default {
   initiate: function(parent, map, layer1, layer2, picture1, picture2, classname){
	privateFns.addBaselayerSwitcher(parent, picture2);
	privateFns.initBaselayerSwitcher(map, layer1, layer2, picture1, picture2);
   }
};
